<template>
<section>
  <LogoLoading v-if="loading"/>
  <div v-show="!loading">
    <div class="container">
      <div class="row">
        <div class="col-12 title py-3">
          <h2 class="align-self-center text-center">{{ $t('shop.title') }}</h2>
        </div>
        <hr>
      </div>  
    </div>
    <div id="shop" class="container-fluid">   
      <BannerSlider/>
      <hr v-if="getFeaturedProductsOutput && getFeaturedProductsOutput.data && getFeaturedProductsOutput.data.length > 0" class="container">
      <FeaturedSlider v-if="getFeaturedProductsOutput && getFeaturedProductsOutput.data && getFeaturedProductsOutput.data.length > 0" :title="$t('shop.featuredTitle')"/>
      <hr v-if="getBestSellersProductsOutput && getBestSellersProductsOutput.data && getBestSellersProductsOutput.data.length > 0" class="container">
      <BestSellersSlider v-if="getBestSellersProductsOutput && getBestSellersProductsOutput.data && getBestSellersProductsOutput.data.length > 0" :title="$t('shop.bestSellersTitle')"/>
      <hr class="container">
      <PublishDateSlider :title="$t('shop.newEntriesTitle')"/>
      <BannerSlider class="py-4"/>
      <hr class="container">
      <LatestViewedSlider />
      <!-- Newsletter -->
      <Newsletter class="py-5 mt-5" />
    </div>
  </div>
</section>
</template>

<script>
import BannerSlider from "@/components/Shop/BannerSlider.vue";
import FeaturedSlider from "@/components/Shop/FeaturedSlider.vue";
import PublishDateSlider from "@/components/Shop/PublishDateSlider.vue";
import BestSellersSlider from "@/components/Shop/BestSellersSlider.vue";
import LatestViewedSlider from "@/components/Shop/LatestViewedSlider.vue";
import Newsletter from "@/components/Newsletter.vue";
import { mapState } from "vuex";
import LogoLoading from "@/components/LogoLoading.vue";
import { API_HELPER } from "@/helpers/api.js";

export default {
  components: {
    BannerSlider,
    FeaturedSlider,
    PublishDateSlider,
    BestSellersSlider,
    Newsletter,
    LatestViewedSlider,
    LogoLoading
  },
  data() {
    return {};
  },
metaInfo () {
    return { 
          title: this.$t("vueRouter.shopTitle"), 
          titleTemplate: '%s - Tabuaço', 
          htmlAttrs: {
            lang: this.$i18n.locale,
          },
          meta: 
          [
            {name: 'description', content: this.$t("vueRouter.shopDescription")},
            {name: 'keywords', content: this.$t("vueRouter.defaultKeywords")},
            // Twitter Card
            {name: 'twitter:card', content: "summary"},
            {name: 'twitter:title', content: this.$t("vueRouter.shopTitle")},
            {name: 'twitter:description', content: this.$t("vueRouter.shopDescription")},
            {name: 'twitter:image', content: API_HELPER.pathJoin([process.env.VUE_APP_URL_ROOT, "assets/logo.png"]) },
            //Facebook OpenGraph
            {property: 'og:title', content: this.$t("vueRouter.shopTitle")},
            {property: 'og:site_name', content: 'Tabuaço'},
            {property: 'og:type', content: 'website'},
            {property: 'og:image', content: API_HELPER.pathJoin([process.env.VUE_APP_URL_ROOT, "assets/logo.png"]) },
            {property: 'og:description', content: this.$t("vueRouter.shopDescription")}
          ], 
          link: [
            {rel: 'alternate', hreflang: 'pt', href: API_HELPER.pathJoin([process.env.VUE_APP_URL_ROOT, this.$t("vueRouter.shop", 'pt')])},
            {rel: 'alternate', hreflang: 'en', href: API_HELPER.pathJoin([process.env.VUE_APP_URL_ROOT, this.$t("vueRouter.shop", 'en')])}
          ]
      } 
    }, 
  computed: {
    ...mapState({
      getBannersOutput: (state) => state.products.bannerOutput,
      getFeaturedProductsOutput: state => state.products.featuredOutput, 
      getBestSellersProductsOutput: state => state.products.bestSellersOutput,    
      getPublishDateProductsOutput: state => state.products.publishDateOutput    
    }),
    loading() {
      return this.getBannersOutput == null || this.getFeaturedProductsOutput == null || this.getBestSellersProductsOutput == null || this.getPublishDateProductsOutput == null;
    }
  },
};
</script>

<style scoped>
hr {
  opacity: 1 !important;
  background-color: transparent;
  border: 1px solid black !important;
  margin-bottom: 1rem;
}
.title h2 {
    margin: 0;
    font-weight: bold !important;
}
</style>
